function ReportCardView(aReportInstance, aAgent, aOrganization) {
    "use strict";

    this.Id = aReportInstance.Id;
    this.ReportId = aReportInstance.ReportId;
    this.ReportInstanceId = aReportInstance.ReportInstanceId;
    this.ReportName = ReportNameFormatter(aReportInstance.ReportName);
    this.ReportDescription = aReportInstance.ReportDescription;
    this.ReportGeneratedDate = DisplayLongDateTime(aReportInstance.ReportGeneratedDate);
    this.UpdatedUTC = aReportInstance.UpdatedUTC;
    this.ReportStatus = reportStatusFormatter(aReportInstance.ReportStatus);
    this.PDFStatus = aReportInstance.PDFStatus;
    this.DOCStatus = aReportInstance.DOCStatus;
    this.XLSStatus = aReportInstance.XLSStatus;
    this.RTFStatus = aReportInstance.RTFStatus;
    this.TXTStatus = aReportInstance.TXTStatus;
    this.CSVStatus = aReportInstance.CSVStatus;
    this.DOCURL = aReportInstance.DOCURL;
    this.PDFURL = aReportInstance.PDFURL;
    this.XLSURL = aReportInstance.XLSURL;
    this.RTFURL = aReportInstance.RTFURL;
    this.TXTURL = aReportInstance.TXTURL;
    this.CSVURL = aReportInstance.CSVURL;

    this.AgentId = aReportInstance.AgentId;
    this.AgentName = localizeText('cEnrolleesMappingUnknown');//'- unknown -';
    if (!isNullOrUndefined(aAgent)) {
        this.AgentName = aAgent.FullName;
    }

    this.OrganizationId = aReportInstance.OrganizationId;
    this.OrganizationName = localizeText('cEnrolleesMappingUnknown');
    if (!isNullOrUndefined(aOrganization)) {
        this.OrganizationName = aOrganization.Name;
    }
}
if (typeof exports !== 'undefined') {
    module.exports = ReportCardView;
}